import { Component, Input } from '@angular/core';
import { IDataTagMount } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-tag-mount',
	templateUrl: './tag-mount.component.html',
	styleUrls: ['./tag-mount.component.scss']
})
export class TagMountComponent {
	@Input() item!: IDataTagMount;
}
